import { render } from "./BorderDetail.vue?vue&type=template&id=7f8dd314&scoped=true&ts=true"
import script from "./BorderDetail.vue?vue&type=script&lang=ts"
export * from "./BorderDetail.vue?vue&type=script&lang=ts"

import "./BorderDetail.vue?vue&type=style&index=0&id=7f8dd314&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f8dd314"]])

export default __exports__